import { ArtMetadataSchema, type ArtMetadata } from "../schedule-presets/art-metadata";
import { metadataToJson } from "../schedule-presets/metadata-json";
import { downloadBlob } from "../download-blob";
import { validateBuilderMetadata } from "./validate-metadata";
import type { BuilderArtwork } from "./artwork";

export function downloadBuilderMetadata(metadata: ArtMetadata, artwork: BuilderArtwork | null | undefined) {
  if (validateBuilderMetadata(metadata, artwork).length) return false;
  // Parse the export schema so only metadata fields enter the download.
  const exported = ArtMetadataSchema.parse(metadata);
  const json = metadataToJson(exported);
  downloadBlob(new Blob([`${json}\n`], { type: "application/json" }), "metadata.json");
  return true;
}
